import { profile, axiosConfig } from 'api';

import { Response } from 'models/response';

export interface PhotoUpload {
  companyId: string;
  file: File | '';
}

export interface PhotoResponse {
  picture: string;
  extension: string;
  url: string;
}

export const getFavicon = (companyId: string): Promise<Response<PhotoResponse>> =>
  profile.get<Response<PhotoResponse>>('companyConfiguration/GetFavicon/' + companyId, axiosConfig).then((response) => response.data);

export const getLogoResellerImage = (companyId: string): Promise<Response<PhotoResponse>> =>
  profile.get<Response<PhotoResponse>>('companyConfiguration/GetLogoReseller/' + companyId, axiosConfig).then((response) => response.data);

export const getLogoCompanyImage = (companyId: string): Promise<Response<PhotoResponse>> =>
  profile.get<Response<PhotoResponse>>('companyConfiguration/GetLogoCompany/' + companyId, axiosConfig).then((response) => response.data);

export const uploadFavicon = (data: FormData): Promise<void> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  return profile
    .post('companyConfiguration/uploadFavicon', data, config)
    .then((response) => true)
    .catch((error) => error.data);
};

export const uploadLogoReseller = (data: FormData): Promise<void> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  return profile
    .post('companyConfiguration/uploadLogoReseller', data, config)
    .then((response) => true)
    .catch((error) => error.data);
};

export const uploadLogoCompany = (data: FormData): Promise<void> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  return profile
    .post('companyConfiguration/uploadLogoCompany', data, config)
    .then((response) => true)
    .catch((error) => error.data);
};
